import type { IService } from 'restangular'

import { app } from '../../app.module'

/**
 * グループを新規作成、編集時に開くモーダル
 * attribute: {number} group-id 編集を行うグループのグループID
 */
class EditGroupModalComponentCtrl {
  private scope: ng.IScope
  private rootScope: ng.IRootScopeService
  private Restangular: IService
  private mdDialog: {
    hide: Function
  }
  private DialogService: {
    showToast: Function
  }
  private groupId: number
  private valid: boolean
  private isLoading: boolean
  private groupData: {
    groupId: number | string
    name: string
    plan: string
    status: number
    memo: string
    sns: string[]
    categories: {}[]
    functions: string[]
  }

  constructor($scope, $rootScope, Restangular, $mdDialog, DialogService) {
    this.scope = $scope
    this.rootScope = $rootScope
    this.Restangular = Restangular
    this.mdDialog = $mdDialog
    this.DialogService = DialogService
    this.isLoading = false
    this.valid = false
  }

  /**
   * 初期化
   */
  public $onInit(): void {
    this.groupData = {
      groupId: this.groupId,
      name: null,
      plan: null,
      memo: null,
      status: null,
      categories: [],
      sns: [],
      functions: [],
    }

    // 編集の場合はデータをサーバーから取得してモーダルにセットする
    if (this.groupId !== undefined) {
      this.setGroupData(this.groupId)
    } else {
      this.groupData.groupId = 'new'
      this.groupData.functions = ['post', 'account', 'analytics', 'archive']
    }

    this.scope.$on('setSNSAccessControl', (event, sns) => {
      this.groupData.sns = sns
      this.validateForm()
    })
    this.scope.$on('setCategoryAccessControl', (event, categories) => {
      this.groupData.categories = categories
      this.validateForm()
    })
    this.scope.$on('setFunctionAccessControl', (event, functions) => {
      this.groupData.functions = functions
      this.validateForm()
    })
  }

  /**
   * グループを保存する
   */
  public saveGroup() {
    // サーバーへPOSTし、toastを出してモーダルを閉じる
    this.Restangular.all(`/group/group`)
      .customPUT(this.groupData)
      .then((response) => {
        if (response[0].error === null) {
          this.DialogService.showToast('グループを保存しました', 'success-toast')
        } else {
          this.DialogService.showToast('グループが保存できませんでした', 'error-toast')
        }
        // スコープが親と分離しているため、$rootScopeでデータ更新のイベントを通知する
        this.rootScope.$broadcast('changeGroupData')
        this.close()
      })
  }

  /**
   * モーダルを閉じる
   */
  public close() {
    this.mdDialog.hide()
  }

  /**
   * サーバーからグループデータを取得し、子コンポーネントにデータを渡す
   * @param {number} groupId グループID
   */
  private setGroupData(groupId: number) {
    this.isLoading = true
    const request = this.Restangular.all(`/group/group?group_id=${groupId}`).getList()

    request.then((response) => {
      const groupData = response[0].data[0]

      this.groupData.name = groupData.name
      this.groupData.plan = groupData.plan
      this.groupData.status = groupData.status
      this.groupData.memo = groupData.memo
      this.groupData.categories = []
      this.groupData.sns = this.setSnsFlg(
        groupData.flgFacebook,
        groupData.flgTwitter,
        groupData.flgInstagram,
        groupData.flgYoutube
      )
      this.groupData.functions = this.setFunctionFlag(
        groupData.flgPost,
        groupData.flgAccount,
        groupData.flgAnalytics,
        groupData.flgArchive
      )

      // カテゴリ一覧はカンマ区切りのstringなので、カンマで分割し配列にする
      if (groupData.categories !== null) {
        this.groupData.categories = groupData.categories.split(',')
      }

      this.validateForm()
      this.isLoading = false
    })
  }

  private setSnsFlg(flgFacebook, flgTwitter, flgInstagram, flgYoutube) {
    const result = []

    if (flgFacebook === 1) {
      result.push('facebook')
    }
    if (flgTwitter === 1) {
      result.push('twitter')
    }
    if (flgInstagram === 1) {
      result.push('instagram')
    }
    if (flgYoutube === 1) {
      result.push('youtube')
    }

    return result
  }

  private setFunctionFlag(flgPost, flgAccount, flgAnalytics, flgArchive) {
    const result = []

    if (flgPost === 1) {
      result.push('post')
    }
    if (flgAccount === 1) {
      result.push('account')
    }
    if (flgAnalytics === 1) {
      result.push('analytics')
    }
    if (flgArchive === 1) {
      result.push('archive')
    }

    return result
  }

  /**
   * フォームに全てデータが入力されているかチェックする
   */
  private validateForm() {
    this.valid = true
    // プランがライトを選択した場合は機能とカテゴリーの値が必要
    if (this.groupData['plan'] === 'lite') {
      if (this.groupData['functions'].length === 0) {
        this.valid = false
      }
      if (this.groupData['categories'].length === 0) {
        this.valid = false
      }
    }
    Object.keys(this.groupData).forEach((key) => {
      // メモ欄は150文字を超えた場合はundefinedとなる
      // メモは空欄でも許可するが、150文字を超えた場合はNGとする
      if (key !== 'memo' && this.groupData[key] === '') {
        this.valid = false
      }
      if (key !== 'memo' && this.groupData[key] === null) {
        this.valid = false
      }
      if (this.groupData[key] === undefined) {
        this.valid = false
      }
    })
  }
}

app.component('editGroupModal', {
  bindings: {
    groupId: '<',
  },
  template: require('./edit-group-modal.pug')(),
  controller: EditGroupModalComponentCtrl,
})
